<template>
  <div>
    <!-- Full list -->

    <div
      v-if="!albumInfo && !manualSelected"
      class="c-gallery"
    >
      <div
        class="c-gallery__filter c-margin-lg--bottom"
      >
        <button
          v-for="filter in filters"
          :key="filter.Id"
          :class="{ selected: filter.Id === mediaSelected }"
          @click="filterByType(filter)"
        >
          <span>
            <c-text
              size="md"
              color="#074E8E"
              weight="600"
              align="center"
              @click="pushGTM"
            >{{
              filter.Description
            }}</c-text>
          </span>
        </button>
      </div>

      <div
        v-if="dataSource.Total > 0"
        class="c-gallery__data"
      >
        <div
          v-for="item in fullData"
          :key="`type${item.Id}`"
          class="c-gallery__container"
        >
          <!-- Description  -->
          <div
            v-if="!toGetMore"
            class="c-gallery__type c-padding-xl--top"
          >
            <c-title
              size="h2"
              color="#1A202C"
              align="center"
            >
              {{ item.Description }}
            </c-title>
          </div>

          <div
            class="c-gallery__list c-margin-lg--top"
            @click="pushGridItemToGTM"
          >
            <div
              v-for="album in item.Albums"
              :key="`album${album.Id}`"
              class="c-gallery__item"
              @click="onClickAlbum(item, album)"
            >
              <div class="c-gallery-card">
                <c-gallery-media
                  :title="album.Title"
                  :description="album.Description"
                  :poster="album.Poster"
                  :alt="album.PosterAlt"
                  :media="album.Media"
                  :template-name="album.TemplateName"
                />
              </div>
            </div>
          </div>

          <div
            v-if="item.HasMore"
            class="c-gallery__actions c-margin-lg--top"
          >
            <div
              class="c-margin-xl--bottom"
              @click.prevent="onClickToShowMore(item)"
            >
              <c-button
                name="ShowMoreButton"
                use-custom-button="secondary"
                @click="pushGTM"
              >
                <c-text
                  size="xs"
                  color="#074E8E"
                  weight="800"
                >
                  {{ model.ShowMoreAll }}
                </c-text>
              </c-button>
            </div>
          </div>
        </div>
      </div>

      <div
        v-else
        class="c-gallery__noresults"
      >
        <c-text
          size="md"
          align="center"
          color="#233037"
        >
          {{ model.NoResults }}
        </c-text>
      </div>
    </div>

    <!-- Details album -->

    <div
      v-if="albumInfo && !manualSelected"
      class="c-gallery"
    >
      <div class="c-gallery__head c-margin-lg--bottom">
        <c-title
          size="h2"
          color="#1A202C"
          align="center"
        >
          {{ albumInfo.Album.Title }}
        </c-title>
        <c-text
          size="xs"
          color="#233037"
          weight="400"
        >
          {{ albumInfo.Total }} {{ albumInfo.CounterLabel }}
        </c-text>
      </div>

      <div class="c-gallery__back c-margin-lg--bottom">
        <div @click.prevent="clickToBack">
          <c-button
            use-custom-button="secondary"
            @click="pushGTM"
          >
            <c-text
              size="xs"
              color="#074E8E"
              weight="800"
            >
              {{ model.BackButton }}
            </c-text>
          </c-button>
        </div>
      </div>

      <div
        class="c-gallery__list c-gallery__checkList"
        @click="pushItemToGTM"
      >
        <div
          v-for="media in albumInfo.Album.Medias"
          :key="`media${media.Id}`"
          class="c-gallery__item"
        >
          <a
            :href="media.Media"
            download
          >
            <c-gallery-media
              class="c-gallery-card"
              :title="media.Title"
              :description="media.Description"
              :poster="media.Poster"
              :alt="media.PosterAlt"
              :media="media.MediaId"
              :template-name="media.TemplateName"
            />
          </a>
        </div>
      </div>

      <div
        v-if="albumInfo.Album.HasMore"
        class="c-gallery__actions c-margin-lg--top"
      >
        <div
          class="c-margin-lg--bottom"
          @click.prevent="onClickAlbumToShowMore(albumInfo.Album)"
        >
          <c-button
            use-custom-button="secondary"
            @click="pushGTM"
          >
            <c-text
              size="xs"
              color="#074E8E"
              weight="800"
            >
              {{ model.ShowMoreCategory }}
            </c-text>
          </c-button>
        </div>
      </div>
    </div>

    <!-- Manual Selection -->

    <div
      v-if="manualSelected"
      class="c-gallery"
    >
      <div class="c-gallery__head c-margin-lg--bottom">
        <c-title
          size="h2"
          color="#1A202C"
          align="center"
        >
          {{ manualSelected.Title }}
        </c-title>
      </div>

      <div>
        <div
          class="c-gallery__list c-gallery__checkList c-margin-lg--top"
          @click="pushItemToGTM"
        >
          <div
            v-for="album in manualSelected.Albums"
            :key="`album${album.Id}`"
            class="c-gallery__item c-gallery__newsItem"
          >
            <a
              :href="`${manualSelected.GalleryPageUrl}?mtype=${album.ParentId}&album=${album.Id}`"
              target="_blank"
              class="c-gallery-card"
            >
              <c-gallery-media
                :title="album.Title"
                :description="album.Description"
                :poster="album.Poster"
                :alt="album.PosterAlt"
                :media="album.Media"
                :template-name="album.TemplateName"
              />
            </a>
          </div>
        </div>

        <div class="c-gallery__actions c-margin-lg--top">
          <div class="c-margin-lg--bottom">
            <c-button
              :href="manualSelected.GalleryPageUrl"
              use-custom-button="secondary"
              @click="pushGTM"
            >
              <c-text
                size="xs"
                color="#074E8E"
                weight="800"
              >
                {{ manualSelected.ShowMore }}
              </c-text>
            </c-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import isOutbound from '@tagging/isOutbound.js'

export default {
  name: 'c-gallery',
  props: {
    endPoint: {
      type: String,
      default: '/api/sitecore/nb/gallery',
    },
    mediaEndPoint: {
      type: String,
      default: '/api/sitecore/nb/mediasbyalbum',
    },
    galleryModel: {
      type: Object,
      default: null,
    },
    manualSelected: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      model: this.galleryModel,
      dataSource: [],
      albumInfo: null,
    }
  },
  computed: {
    toGetMore() {
      const { MediaTypeSelected } = this.dataSource
      return MediaTypeSelected && this.model.Id !== MediaTypeSelected.Id
    },
    mediaSelected() {
      const { MediaTypeSelected } = this.dataSource

      let value = this.model.Id

      if (MediaTypeSelected) {
        value = MediaTypeSelected.Id
      }

      return value
    },
    filters() {
      return this.galleryModel ? this.galleryModel.Filters : []
    },
    fullData() {
      return this.dataSource.MediaTypes
    },
  },
  watch: {
    albumInfo(val) {
      this.updateQuery(val)

      this.$nextTick(() => {
        const gallery = document.querySelector('.c-gallery__checkList')
        const mediaCount = val?.Album?.Medias?.length || 0

        if (gallery) {
          if (mediaCount < 3) {
            gallery.classList.add('few-items')
          }
        }
      })
    },
    dataSource(values) {
      this.updateQuery(values)
    }
  },
  created() {
    if (this.manualSelected) return

    const urlParams = new URLSearchParams(window.location.search)

    const type = urlParams.get('mtype')
    const album = urlParams.get('album')

    if (type && !album) {
      this.model.MediaTypeSelected = {
        Id: type,
      }
      this.getData(this.model)
    } else if (
      type
      && album
      && album.toLowerCase() !== this.model.Id.toLowerCase()
    ) {
      this.onClickAlbum({ Id: type }, { Id: album })
    } else {
      this.getData(this.model)
    }
  },
  mounted() {
    const gallery = document.querySelector('.c-gallery__checkList')
    if (gallery && gallery.children.length < 3) {
      gallery.classList.add('few-items')
    }
  },
  methods: {
    parents(el, selector) {
      let parentContainer = el

      do {
        parentContainer = parentContainer.parentNode
      } while (
        !parentContainer.matches(selector)
        && parentContainer !== document.body
      )

      return parentContainer
    },
    updateQuery() {
      let url = window.location.pathname

      const urlParams = new URLSearchParams(window.location.search)

      const { MediaTypeSelected, AlbumSelected } = this.model

      if (MediaTypeSelected && MediaTypeSelected.Id !== this.model.Id) {
        urlParams.set('mtype', MediaTypeSelected.Id)
      } else {
        urlParams.delete('mtype')
      }

      if (AlbumSelected) {
        urlParams.set('album', AlbumSelected.Id)
      } else {
        urlParams.delete('album')
      }

      const queryString = urlParams.toString()
      if (queryString) {
        url = `${url}?${queryString}`
      }

      window.history.pushState(urlParams.toString(), '', url)
    },
    filterByType(item) {
      this.model.AlbumSelected = null

      if (item.Id !== this.model.Id) {
        this.model.MediaTypeSelected = item
        this.getData(this.model)
      } else {
        this.model.MediaTypeSelected = null
        this.getData(this.galleryModel)
      }
    },
    getData(params) {
      axios({
        method: 'POST',
        url: this.endPoint,
        data: params,
      }).then((result) => {
        this.dataSource = result.data
      })
    },
    onClickToShowMore(item, event) {
      if (this.toGetMore) {
        this.model.Filters = this.model.Filters.map((filter) => {
          if (filter.Id === item.Id) {
            filter.ShowItems = item.ShowItems + item.ShowItemsIncrement
          }
          return filter
        })
        this.getData(this.model)
      } else {
        this.model.Filters = this.model.Filters.map((filter) => {
          if (filter.Id === item.Id) {
            filter.ShowItems = item.ShowItems + item.ShowItemsIncrement
          }
          return filter
        })
        this.filterByType({ Id: item.Id })
      }

      if (event && event.target) {
        this.moveToUp(event.target)
      }
    },
    moveToUp(event) {
      if (!event) return

      const el = event.target

      const element = this.parents(el, '.c-gallery__data')

      if (element) {
        const lastItem = element.querySelector('.c-gallery__list').lastElementChild.offsetTop
        window.scrollTo(0, lastItem)
      }
    },
    onClickAlbumToShowMore(album) {
      const param = this.model
      param.AlbumSelected.ShowItems = album.ShowItems + album.ShowItemsIncrement

      axios({
        method: 'POST',
        url: this.mediaEndPoint,
        data: param,
      }).then((result) => {
        const { data } = result
        this.albumInfo = data
      })
    },
    onClickAlbum(mediaType, album, event) {
      const param = this.model

      param.MediaTypeSelected = mediaType
      param.AlbumSelected = album

      axios({
        method: 'POST',
        url: this.mediaEndPoint,
        data: param,
      }).then((result) => {
        const { data } = result
        this.albumInfo = data

        if (event && event.target) {
          this.moveToUp(event.target)
        }
      })
    },
    clickToBack() {
      this.albumInfo = null
      if (!this.fullData || !this.fullData.length) {
        this.model.MediaTypeSelected = null
        this.getData(this.galleryModel)
      }

      this.model.AlbumSelected = null

      this.updateQuery()
    },
    pushGTM(event) {
      const target = event.target.closest('button, a')

      window.dataLayer.push({
        event: 'click',
        section: 'Multimídias',
        label: target.innerText || '',
        outbound: isOutbound(target)
      })
    },
    hasPlayerIconInItem(item) {
      return item?.querySelector('.play-button') !== null
    },
    pushItemToGTM(event) {
      const title = event.target.closest('.c-gallery__item')
      const section = this.hasPlayerIconInItem(title) ? 'multimidias-video' : 'multimidias-imagem'
      const titlePageOpen = document.querySelector('.c-gallery__head')?.querySelector('.c-title')
      const link = title.querySelector('a')?.getAttribute('href')
      const extension = link?.split('.').pop()

      window.dataLayer.push({
        event: 'file_download',
        section,
        gallery_name: title?.innerText || titlePageOpen?.innerText || '',
        gallery_results: this.albumInfo?.Total ?? '',
        file_extension: extension ?? '',
        link_url: link ?? ''
      })
    },
    pushGridItemToGTM(event) {
      const title = event.target.closest('.c-gallery__item')
      const section = this.hasPlayerIconInItem(title) ? 'multimidias-video' : 'multimidias-imagem'

      window.dataLayer.push({
        event: 'click',
        section,
        gallery_name: title?.innerText || '',
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.c-gallery__head {
  $head: &;
  display: flex;
  flex-direction: column;
  align-items: center;

  #{$head}--detail {
    display: flex;
    flex-direction: row;
  }
}

.c-gallery__type {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.c-gallery__noresults {
  padding: 1.875rem;
  justify-content: center;
}

.c-gallery__back {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.c-gallery__container:nth-of-type(2) {
  background-color: $blue-06;
}

.c-gallery__list {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  justify-content: center;

  @include screen-size('sm') {
    grid-template-columns: repeat(2, 1fr);
  }

  @include screen-size('xlg') {
    grid-template-columns: repeat(3, 1fr);
  }
}

.c-gallery__checkList {
  &.few-items {
    display: flex;
    flex-direction: column;
    justify-items: center;

    @include screen-size('xlg') {
      flex-direction: row;
    }

    .c-gallery__item {
      width: 100%;
    }
  }
}

.c-gallery__actions {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.c-gallery__filter {
  display: flex;
  justify-content: center;
  gap: 2rem;

  & button {
    display: flex;
    flex-direction: column;
    justify-content: center;

    & span {
      padding: 0.5rem;
    }

    &.selected {
      background-color: $blue-06;
    }
  }
}

.c-gallery__item {
  flex: 1;
  min-width: 18.75rem;
  padding: 2%;

  & a {
    text-decoration: none;
  }

  & .c-gallery-card {
    text-decoration: none;

    &:hover {
      cursor: pointer;
    }
  }
}

.c-gallery__newsItem {
  max-width: unset !important;
  min-width: 18.75rem;
}
</style>
